module.exports = __webpack_public_path__ + "static/media/country_gm.ddaf0ac1.webp";